
import { Record, Union } from "../fable_modules/fable-library-js.5.3.0/Types.js";
import { record_type, option_type, string_type, class_type, union_type, int32_type } from "../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { Result_Bind, FSharpResult$2 } from "../fable_modules/fable-library-js.5.3.0/Result.js";
import { Operators_IsNull } from "../fable_modules/fable-library-js.5.3.0/FSharp.Core.js";
import { substring, printf, toText, isNullOrWhiteSpace } from "../fable_modules/fable-library-js.5.3.0/String.js";
import { isMatch } from "../fable_modules/fable-library-js.5.3.0/RegExp.js";
import { PositiveAmountModule_create, NonEmptyString_$reflection, NonEmptyStringModule_create } from "./BaseTypes.js";
import { addYears, compare } from "../fable_modules/fable-library-js.5.3.0/Date.js";
import { toString, round, equals, op_Division, op_Multiply, fromParts, compare as compare_1 } from "../fable_modules/fable-library-js.5.3.0/Decimal.js";

export const ChallengeErrors_notFound = "Challenge not found";

/**
 * Valid duration range for challenges (3-31 days)
 */
export class ChallengeDuration extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["ChallengeDuration"];
    }
}

export function ChallengeDuration_$reflection() {
    return union_type("Shared.ChallengeDuration", [], ChallengeDuration, () => [[["Item", int32_type]]]);
}

export const ChallengeDurationModule_minDays = 3;

export const ChallengeDurationModule_maxDays = 31;

export function ChallengeDurationModule_create(days) {
    if ((days >= ChallengeDurationModule_minDays) && (days <= ChallengeDurationModule_maxDays)) {
        return new FSharpResult$2(0, [new ChallengeDuration(days)]);
    }
    else {
        return new FSharpResult$2(1, [`Duration must be between ${ChallengeDurationModule_minDays} and ${ChallengeDurationModule_maxDays} days`]);
    }
}

export function ChallengeDurationModule_value(_arg) {
    return _arg.fields[0] | 0;
}

export const ChallengeTitle_minLength = 5;

export const ChallengeTitle_maxLength = 100;

/**
 * Validate a challenge title. Returns NonEmptyString on success.
 */
export function ChallengeTitle_validate(title) {
    const trimmed = Operators_IsNull(title) ? title : title.trim();
    if (isNullOrWhiteSpace(trimmed)) {
        return new FSharpResult$2(1, ["Title is required"]);
    }
    else if (trimmed.length < ChallengeTitle_minLength) {
        return new FSharpResult$2(1, [`Title must be at least ${ChallengeTitle_minLength} characters`]);
    }
    else if (trimmed.length > ChallengeTitle_maxLength) {
        return new FSharpResult$2(1, [`Title must be ${ChallengeTitle_maxLength} characters or fewer`]);
    }
    else if (isMatch(/[<>]/gu, trimmed)) {
        return new FSharpResult$2(1, ["Title cannot contain < or > characters"]);
    }
    else {
        return NonEmptyStringModule_create(trimmed);
    }
}

export const DailyLogTitle_maxLength = 200;

export function DailyLogTitle_validate(s) {
    const trimmed = Operators_IsNull(s) ? s : s.trim();
    if (isNullOrWhiteSpace(trimmed)) {
        return new FSharpResult$2(1, ["Title is required"]);
    }
    else if (trimmed.length > DailyLogTitle_maxLength) {
        return new FSharpResult$2(1, [`Title must be ${DailyLogTitle_maxLength} characters or fewer`]);
    }
    else {
        return NonEmptyStringModule_create(trimmed);
    }
}

/**
 * Validate a challenge start date against today's date.
 * Callers pass today's date explicitly for testability.
 */
export function StartDate_validate(today, date) {
    if (compare(date, today) < 0) {
        return new FSharpResult$2(1, ["Start date cannot be in the past"]);
    }
    else if (compare(date, addYears(today, 1)) > 0) {
        return new FSharpResult$2(1, ["Start date must be within the next year"]);
    }
    else {
        return new FSharpResult$2(0, [date]);
    }
}

export const DailyLogNote_maxLength = 5000;

export function DailyLogNote_validate(input) {
    let matchResult, s;
    if (input != null) {
        if (input === "") {
            matchResult = 0;
        }
        else {
            matchResult = 1;
            s = input;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return new FSharpResult$2(0, [undefined]);
        default: {
            const trimmed = Operators_IsNull(s) ? s : s.trim();
            if (isNullOrWhiteSpace(trimmed)) {
                return new FSharpResult$2(0, [undefined]);
            }
            else if (trimmed.length > DailyLogNote_maxLength) {
                return new FSharpResult$2(1, [`Note must be ${DailyLogNote_maxLength} characters or fewer`]);
            }
            else {
                return new FSharpResult$2(0, [trimmed]);
            }
        }
    }
}

/**
 * Challenge theme (e.g., "walk", "read", "meditate")
 */
export class ChallengeTheme extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["ChallengeTheme"];
    }
}

export function ChallengeTheme_$reflection() {
    return union_type("Shared.ChallengeTheme", [], ChallengeTheme, () => [[["Item", NonEmptyString_$reflection()]]]);
}

/**
 * Unit of measurement for the challenge (e.g., "miles", "pages", "minutes")
 */
export class ChallengeUnit extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["ChallengeUnit"];
    }
}

export function ChallengeUnit_$reflection() {
    return union_type("Shared.ChallengeUnit", [], ChallengeUnit, () => [[["Item", NonEmptyString_$reflection()]]]);
}

/**
 * Charity information from every.org
 */
export class CharityInfo extends Record {
    constructor(Id, Name, Ein, Slug, LogoUrl, Description) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Ein = Ein;
        this.Slug = Slug;
        this.LogoUrl = LogoUrl;
        this.Description = Description;
    }
}

export function CharityInfo_$reflection() {
    return record_type("Shared.CharityInfo", [], CharityInfo, () => [["Id", class_type("System.Guid")], ["Name", string_type], ["Ein", string_type], ["Slug", string_type], ["LogoUrl", option_type(string_type)], ["Description", option_type(string_type)]]);
}

/**
 * Goal achievement status
 */
export class GoalStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotMet", "Met", "Exceeded"];
    }
}

export function GoalStatus_$reflection() {
    return union_type("Shared.GoalStatus", [], GoalStatus, () => [[], [], []]);
}

/**
 * Derive goal status from completed units and target amount.
 * Both values are expected to be non-negative decimals, and target should normally be positive.
 * If target is zero or negative, returns NotMet instead of dividing.
 */
export function GoalStatusModule_fromCompletionRatio(completed, target) {
    if (compare_1(target, fromParts(0, 0, 0, false, 0)) <= 0) {
        return new GoalStatus(0, []);
    }
    else {
        const percentage = op_Multiply(op_Division(completed, target), fromParts(100, 0, 0, false, 0));
        if (compare_1(percentage, fromParts(100, 0, 0, false, 0)) < 0) {
            return new GoalStatus(0, []);
        }
        else if (equals(percentage, fromParts(100, 0, 0, false, 0))) {
            return new GoalStatus(1, []);
        }
        else {
            return new GoalStatus(2, []);
        }
    }
}

/**
 * Display text for a floor: whole numbers without decimals, fractional values unrounded.
 */
export function MinAllowedGoal_format(floor) {
    if (equals(floor, round(floor))) {
        return toText(printf("%.0f"))(floor);
    }
    else {
        return toString(floor);
    }
}

/**
 * Validate a proposed goal against the floor.
 */
export function MinAllowedGoal_validate(floor, amount) {
    return Result_Bind((a) => {
        let arg;
        if (compare_1(amount, floor) >= 0) {
            return new FSharpResult$2(0, [a]);
        }
        else {
            return new FSharpResult$2(1, [(arg = MinAllowedGoal_format(floor), toText(printf("Must be at least %s, the highest goal a supporter pledged against"))(arg))]);
        }
    }, PositiveAmountModule_create(amount));
}

/**
 * Challenge status types
 */
export class ChallengeStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Draft", "Planned", "Published", "Pledged", "Active", "Finalizing", "Finalized", "Abandoned"];
    }
}

export function ChallengeStatus_$reflection() {
    return union_type("Shared.ChallengeStatus", [], ChallengeStatus, () => [[], [], [], [], [], [], [], []]);
}

/**
 * Parses the lowercase status string used in view DB rows and API responses
 */
export function ChallengeStatusModule_tryParse(s) {
    switch (s) {
        case "draft":
            return new ChallengeStatus(0, []);
        case "planned":
            return new ChallengeStatus(1, []);
        case "published":
            return new ChallengeStatus(2, []);
        case "pledged":
            return new ChallengeStatus(3, []);
        case "active":
            return new ChallengeStatus(4, []);
        case "finalizing":
            return new ChallengeStatus(5, []);
        case "finalized":
            return new ChallengeStatus(6, []);
        case "abandoned":
            return new ChallengeStatus(7, []);
        default:
            return undefined;
    }
}

/**
 * Singularize a unit name for "$X.XX/unit" display
 */
export function UnitName_singular(unitName) {
    const lower = unitName.toLowerCase();
    if (lower.endsWith("s") && (lower.length > 1)) {
        return substring(lower, 0, lower.length - 1);
    }
    else {
        return lower;
    }
}

/**
 * Fee types for challenges
 */
export class ChallengeFeeType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Standard", "Discounted"];
    }
}

export function ChallengeFeeType_$reflection() {
    return union_type("Shared.ChallengeFeeType", [], ChallengeFeeType, () => [[], []]);
}

export function ChallengeFee_amount(_arg) {
    if (_arg.tag === 1) {
        return fromParts(925, 0, 0, false, 2);
    }
    else {
        return fromParts(1850, 0, 0, false, 2);
    }
}

//# sourceMappingURL=Challenge.js.map
